"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "@/components/ui/Link";
import LiveBlink from "@/components/ui/LiveBlink";
import { isLiveBlogValue } from "@/lib/liveBlog";
import { useRouter } from "next/navigation";
import { MessageIcon } from "../ui/message-icon";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import { getTimeAgo, getSectionUrl, toFieldString } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string | boolean;
  customClass?: string;
};
type Props = {
  title?: FieldConfig;
  timeAgo?: FieldConfig;
  category?: FieldConfig;
  sectionUrl?: string;
  slug?: string;
  templatetype?: FieldConfig;
  isliveblog?: FieldConfig;
};
export const VerticalCategoryNews = t0 => {
  const $ = _c(49);
  const {
    title: t1,
    timeAgo: t2,
    category: t3,
    sectionUrl,
    slug,
    templatetype: t4,
    isliveblog: t5
  } = t0;
  let t6;
  if ($[0] !== t1) {
    t6 = t1 === undefined ? {
      hidden: false,
      value: "\u0BAF\u0BBE\u0BB0\u0BCD \u0B95\u0BAE\u0BB2\u0BBF\u0BA9\u0BCD \u0BAA\u0BC6\u0BB0\u0BBF\u0BAF \u0BB0\u0B9A\u0BBF\u0B95\u0BB0\u0BCD? \u0B87\u0BA8\u0BCD\u0BA4 \u0B9A\u0BA8\u0BCD\u0BA4\u0BC8\u0BC8\u0BAF\u0BBF\u0BB2\u0BCD \u0B9A\u0B9F\u0BCD\u0B9F\u0BC8 \u0B95\u0BBF\u0BB4\u0BBF\u0BAF\u0BBE\u0BA4\u0BC1: \u0BB2\u0BCB\u0B95\u0BC7\u0BB7\u0BCD \u0BAA\u0BC1\u0B95\u0BB4\u0BCD\u0BA8\u0BCD\u0BA4 \u0B95\u0BCA\u0BB3\u0BA4\u0BCD\u0BA4\u0BAE\u0BCD \u0BAE\u0BC7\u0BA9\u0BA9\u0BCD!",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const title = t6;
  const timeAgo = t2 === undefined ? {
    hidden: false,
    value: "1 hour ago",
    customClass: ""
  } : t2;
  let t7;
  if ($[2] !== t3) {
    t7 = t3 === undefined ? {
      hidden: false,
      value: "India",
      customClass: ""
    } : t3;
    $[2] = t3;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const category = t7;
  let t8;
  if ($[4] !== t4) {
    t8 = t4 === undefined ? {
      hidden: false,
      value: "",
      customClass: ""
    } : t4;
    $[4] = t4;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const templatetype = t8;
  let t9;
  if ($[6] !== t5) {
    t9 = t5 === undefined ? {
      hidden: false,
      value: "",
      customClass: ""
    } : t5;
    $[6] = t5;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  const isliveblog = t9;
  const router = useRouter();
  const t10 = title?.value;
  let t11;
  if ($[8] !== t10) {
    t11 = toFieldString(t10);
    $[8] = t10;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  const titleValue = t11;
  const timeAgoValue = getTimeAgo(toFieldString(timeAgo?.value));
  const t12 = category?.value;
  let t13;
  if ($[10] !== t12) {
    t13 = toFieldString(t12);
    $[10] = t12;
    $[11] = t13;
  } else {
    t13 = $[11];
  }
  const categoryValue = t13;
  let t14;
  if ($[12] !== isliveblog?.value || $[13] !== templatetype?.value) {
    t14 = isLiveBlogValue(templatetype?.value) || isLiveBlogValue(isliveblog?.value);
    $[12] = isliveblog?.value;
    $[13] = templatetype?.value;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  const isLiveBlog = t14;
  let t15;
  if ($[15] !== sectionUrl) {
    t15 = getSectionUrl(sectionUrl);
    $[15] = sectionUrl;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  const sectionUrlValue = t15;
  let t16;
  if ($[17] !== router || $[18] !== sectionUrlValue) {
    t16 = e => {
      if (sectionUrlValue) {
        e.preventDefault();
        e.stopPropagation();
        router.push(sectionUrlValue);
      }
    };
    $[17] = router;
    $[18] = sectionUrlValue;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  const handleCategoryClick = t16;
  let t17;
  if ($[20] !== category?.customClass || $[21] !== category?.hidden || $[22] !== categoryValue || $[23] !== handleCategoryClick || $[24] !== sectionUrlValue) {
    t17 = !category?.hidden && (sectionUrlValue ? <span className={`text-11-tamil-600 text-012061 uppercase tracking-wide hover:underline cursor-pointer ${category?.customClass || ""}`} onClick={handleCategoryClick}>{categoryValue}</span> : <p className={`text-11-tamil-600 text-012061 uppercase tracking-wide ${category?.customClass || ""}`}>{categoryValue}</p>);
    $[20] = category?.customClass;
    $[21] = category?.hidden;
    $[22] = categoryValue;
    $[23] = handleCategoryClick;
    $[24] = sectionUrlValue;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] !== isLiveBlog || $[27] !== title?.customClass || $[28] !== title?.hidden || $[29] !== titleValue) {
    t18 = !title?.hidden && <p className={`text-14-tamil-700 leading-[1.4] text-1B1B1B ${title?.customClass || ""}`}>{isLiveBlog && <LiveBlink />}{titleValue}</p>;
    $[26] = isLiveBlog;
    $[27] = title?.customClass;
    $[28] = title?.hidden;
    $[29] = titleValue;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== timeAgo?.customClass || $[32] !== timeAgo?.hidden || $[33] !== timeAgoValue) {
    t19 = !timeAgo?.hidden && <span className={`text-12-tamil-500 text-1B1B1B ${timeAgo?.customClass || ""}`}>{timeAgoValue}</span>;
    $[31] = timeAgo?.customClass;
    $[32] = timeAgo?.hidden;
    $[33] = timeAgoValue;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  const t20 = slug ? `/${slug}` : undefined;
  let t21;
  if ($[35] !== slug || $[36] !== t20 || $[37] !== titleValue) {
    t21 = <div className="flex gap-3"><MessageIcon id="message-icon-2" slug={slug} category={BOOKMARK_CATEGORIES.NEWS} title={titleValue} articleUrl={t20} /></div>;
    $[35] = slug;
    $[36] = t20;
    $[37] = titleValue;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== t19 || $[40] !== t21) {
    t22 = <div className="flex justify-between items-center">{t19}{t21}</div>;
    $[39] = t19;
    $[40] = t21;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  let t23;
  if ($[42] !== t17 || $[43] !== t18 || $[44] !== t22) {
    t23 = <div className="flex flex-col overflow-hidden p-4 gap-4"><div className="flex flex-col gap-3">{t17}{t18}{t22}</div></div>;
    $[42] = t17;
    $[43] = t18;
    $[44] = t22;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  const content = t23;
  if (slug) {
    const t24 = `/${slug}`;
    let t25;
    if ($[46] !== content || $[47] !== t24) {
      t25 = <Link href={t24} className="block  transition-colors cursor-pointer">{content}</Link>;
      $[46] = content;
      $[47] = t24;
      $[48] = t25;
    } else {
      t25 = $[48];
    }
    return t25;
  }
  return content;
};